var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alarm-time-list"},[_c('div',{staticClass:"device-name"},[_vm._v("单灯近七天能耗")]),_c('div',{staticClass:"tabList"},[_c('chartsBar',{key:_vm.setRefresh,attrs:{"option":_vm.chartsLineData,"id":"chartsLineData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }